export * from './get-mime-type.pipe';
export * from '../img-base64.component';
